/* Copyright (c) Nexign, JSC, 2025.
*/
/**
 * InstructionLink component
 *
 * @author Nikolay Sviridov
 * @version 1.38.0
 * @since 1.38.0
 */

import styled from 'styled-components';

export const InstructionLinkDivStyled = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: 8px;
`;
